import React from "react";
import Skill from "./Skill/Skill";
import Project from "./Project/Project";
import Services from "./Services/Services";
import classes from "./Content.module.css";
import Experience from "./Experience/Experience";
const Content = () => {
  return (
    <div className={classes.Content}>
      <Skill />
      <Project />
      <Services />
      <Experience />
    </div>
  );
};

export default Content;
